/* istanbul ignore file */

import "./answer.scss";
import { useEffect, useRef, useState } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import EnhancedSources from "../sources/enhanced-sources"; // Import the enhanced sources component

import remarkRehype from "remark-rehype";
import rehypeRaw from "rehype-raw";
import useApi from "../../hooks/useApi";
import { useDispatch, useSelector } from "react-redux";
import {
  setInteractionId,
  setAnswer,
  showAnswer,
  showSources,
  hideSources,
  setSources,
  resetSources,
  showError,
  openSources,
  showRetryErrorMsg,
  hideRetryErrorMsg,
  hideError,
} from "../../state/slice";

const Answer = (props: any) => {
  const logo = require("../../assets/world-cc-logo-only.ico");
  const loader = require("../../assets/loader-think.gif");
  const logo2 = require("../../assets/flags.svg")?.default;
  const logo3 = require("../../assets/source-data.png");
  const question = props?.question;
  const currentUser = useSelector((state: any) => state.user);
  const currentQuestion = useSelector((state: any) => state.question);
  const showAnswer1 = useSelector((state: any) => state.showAnswer);

  const currentAnswer = useSelector((state: any) => state.answer);
  const currentSources = useSelector((state: any) => state.sources);
  const isRetryingErrorMsg = useSelector((state: any) => state.showRetryError);

  const currentChatHistoryId = useSelector((state: any) => state.chatHistoryId);

  const [answer2] = useState("");
  const { post } = useApi();
  const [interactionID, setInteractionID] = useState(-1);
  const [currentUserId] = useState(currentUser?.id);

  const initialFetchController = useRef(new AbortController());
  const streamFetchController = useRef(new AbortController());

  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [isResponseCalled, setIsResponseCalled] = useState(false);
  const answerRef = useRef("");
  const isStreaming = useRef(false);

  function MarkdownComponent() {
    return (
      <div className="markdown-styles">
        {isResponseCalled && (
          <ReactMarkdown
            className="markdown-content"
            rehypePlugins={[rehypeRaw]}
            remarkPlugins={[remarkGfm, remarkRehype]}
          >
            {currentAnswer}
          </ReactMarkdown>
        )}
        <ReactMarkdown
          className="markdown-content answers2"
          rehypePlugins={[rehypeRaw]}
          remarkPlugins={[remarkGfm, remarkRehype]}
        >
          {answer2}
        </ReactMarkdown>
      </div>
    );
  }

  useEffect(() => {
    answerRef.current = currentAnswer;
  }, [currentAnswer]);
  const fetchInteractionId = async () => {
    console.log("triggering interaction api");
    dispatch(hideError());
    try {
      const bodyParam = {
        user_id: currentUser?.id,
        question: question,
      };
      // console.log("interaction api calling api from here")
      const response = await post("interactions/", bodyParam);

      if (response && response?.status === 200) {
        // console.log("response interactionid", response);
        setInteractionID(response.data.id);
      } else {
        handleError();
      }
    } catch (error) {
      console.log(error);

      if (error === "AbortError" || error.name === "AbortError") {
        console.log("Stream fetch aborted");
      } else {
        handleError();
        console.error("Stream fetch error:", error);
      }
    }
  };

  useEffect(() => {
    if (interactionID !== -1) {
      dispatch(setInteractionId(interactionID));
      fetchSources();
    }
  }, [interactionID]);

  useEffect(() => {
    if (currentChatHistoryId > -1 && currentAnswer !== "") {
      setIsResponseCalled(true);
    }
  }, [currentChatHistoryId]);

  useEffect(() => {
    console.log("answer component first load");
    return () => {
      console.log("Aborting fetch...");
      initialFetchController.current.abort("AbortError"); // Abort the fetch when component unmounts
      streamFetchController.current.abort("AbortError"); // Abort the fetch when component unmounts
    };
  }, []);

  const fetchSources = async () => {
    // console.log("triggering citations");
    // console.log("before aborting",initialFetchController.current,currentAnswer);
    initialFetchController.current.abort("AbortError");
    streamFetchController.current.abort("AbortError");

    answerRef.current = "";
    isStreaming.current = false;
    dispatch(setAnswer(""));
    initialFetchController.current = new AbortController();
    streamFetchController.current = new AbortController();
            // console.log("after aborting",initialFetchController.current,currentAnswer);

    try {
      dispatch(resetSources([]));
      dispatch(hideSources());
      const citationBodyParam = {
        interaction_id: interactionID,
        user_id: currentUserId,
      };
      const citationsResponse = await fetch(
        `${process.env.REACT_APP_NEW_API_URL}/interactions/generate_citations`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(citationBodyParam),
          signal: streamFetchController.current.signal,
        }
      );
      setTimeout(() => {
        answerRef.current = "";
        isStreaming.current = false;
        dispatch(setAnswer("")); // set again even if same string
      }, 0);
      if (!citationsResponse.ok || !citationsResponse.body) {
        throw citationsResponse.statusText;
      }
      let prevLine = [];

      const reader = citationsResponse.body.getReader();
      const decoder = new TextDecoder("utf-8");
      let sourceCount = 0;
      while (true) {
        const { value, done } = await reader.read();

        //   console.log("value=",value,done)
        if (done) {
          console.log("sources done");
          //   setLoading(false);
          // setIsSourcesLoading(false);
          setIsLoading(false);
          setCurrentLoaderMessagge(finalmessage);
          setIsLoading(true);
          if (sourceCount > 0) {
            dispatch(showSources());
          }

          fetchResponse();
          break;
        }
        const decodedChunk = decoder.decode(value, { stream: true });
        const lines = decodedChunk.split("\n");

        lines.forEach((line) => {
          // console.log("line===>",line);
          const isnew = line.startsWith("event: ") || line.startsWith("data: ");
          if (isnew) {
            prevLine = [];
          }
          if (!isnew) {
            prevLine.push(line);
            try {
              const jsonEventData = JSON.parse(prevLine.join(""));
              sourceCount = sourceCount + 1;
              dispatch(setSources(jsonEventData["content"]));
              prevLine = [];
            } catch (error) {}
          }
          if (line.startsWith("data: ")) {
            const eventData = line.substring(6).trim();
            // console.log("hello eventData===>",eventData);
            // console.log("hello prevLine===>",prevLine);
            // console.log("hello join===>",prevLine+eventData);
            try {
              const jsonEventData = JSON.parse(eventData);
              // console.log("hello parsed above clearing prev", jsonEventData);

              // console.log(`Event data: ${JSON.stringify(jsonEventData)}`);
              if (jsonEventData?.event === "content_delta") {
                sourceCount = sourceCount + 1;
                dispatch(setSources(jsonEventData["content"]));
              }
              // setSources((prevSources: any) => [
              //   ...prevSources,
              //   jsonEventData["content"],
              // ]);
              // console.log("citationsss=====>>>", jsonEventData["content"]);
            } catch (error) {
              // console.error(`Error parsing event data: ${error}`);
              if (error.name === "AbortError") {
                console.log("Stream fetch aborted1");
              } else {
                prevLine.push(eventData);
              }
            }
          }

          // console.log("sources=", sources);
        });
      }
    } catch (error) {
      if (error === "AbortError" || error.name === "AbortError") {
        console.log("Stream fetch aborted");
      } else {
        handleError();
        console.error("Stream fetch error:", error);
      }
    }
  };

  const handleError = () => {
    dispatch(showError());
  };
  // console.log("isRetryingErrorMsg", isRetryingErrorMsg);
  const handleRetryError = () => {
    initialFetchController.current.abort("Retrying"); // Abort the prev  fetch during retry
    streamFetchController.current.abort("Retrying"); // Abort the prev fetch during retry
    dispatch(showRetryErrorMsg());
    answerRef.current = "";
    isStreaming.current = false;
    dispatch(setAnswer(""));

    fetchResponse();
  };
  // console.log("isResponseCalled dimple", isResponseCalled);
  const fetchResponse = async () => {
    initialFetchController.current = new AbortController();
    streamFetchController.current = new AbortController();
    // console.log("show answer", currentAnswer);
    setIsResponseCalled(false);
    isStreaming.current = true;
    // console.log("hiding response dimple",isResponseCalled);

    try {
      const citationBodyParam = {
        interaction_id: interactionID,
        user_id: currentUserId,
      };
      const citationsResponse = await fetch(
        `${process.env.REACT_APP_NEW_API_URL}/interactions/generate_response`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(citationBodyParam),
          signal: initialFetchController.current.signal,
        }
      );
      if (!citationsResponse.ok) {
        throw new Error(`HTTP error! Status: ${citationsResponse.status}`);
      }

      if (!citationsResponse.body) {
        throw new Error(
          "ReadableStream not supported or response body is empty."
        );
      }
      const reader = citationsResponse.body.getReader();
      const decoder = new TextDecoder("utf-8");
      let temp = false;
      setIsResponseCalled(true);
      // console.log("showing response dimple",isResponseCalled);

      console.log("setting temp=false init", isRetryingErrorMsg);

      // if (isRetryingErrorMsg === true) {
      setTimeout(() => {
        console.log("setting retruy msg to show false");
        dispatch(hideRetryErrorMsg());
      }, 5000);

      // }

      while (true) {
        const { value, done } = await reader.read();
        // setIsAnswerLoading(false);
        // console.log("value=", value, done);
        if (done) {
          console.log("done");
          //   setLoading(false);
          dispatch(showAnswer());
          break;
        }

        const decodedChunk = decoder.decode(value, { stream: true });
        const lines = decodedChunk.split("\n");
        if (temp) {
          break;
        }
        lines.forEach((line) => {
          if (temp) {
            return;
          }
          if (!isStreaming.current) return;
          if (line.startsWith("event: ")) {
            // const eventType = line.substring(7).trim();
            // console.log(`Event type: ${eventType}`, line);
            // setTimeout(() => {
            //   if (!temp) {
            //     console.log("Retrying...");
            //     handleRetryError();
            //     temp = true;
            //   }
            // }, 8000);
          } else if (line.startsWith("data: ")) {
            const eventData = line.substring(6).trim();
            // console.log("eventData=1==>", eventData);
            try {
              const jsonEventData = JSON.parse(eventData);
              // console.log(`Event data: ${JSON.stringify(jsonEventData)}`);

              if (jsonEventData?.event === "error") {
                const eventData = line.substring(6).trim();
                // console.log("error eventData===>", eventData);
                const jsonEventData = JSON.parse(eventData);
                // console.log("error jsonEventData===>", jsonEventData);
                if (
                  jsonEventData?.content?.consumer_action === "retry" &&
                  jsonEventData?.content?.error_code === 529
                ) {
                  console.log("Retrying...");

                  handleRetryError();
                  temp = true;
                  return;
                }
              }

              if (jsonEventData?.event === "content_delta")
                if (isLoading) {
                  setIsLoading(false);
                }
              const newVal =
                answerRef.current + jsonEventData["content"]["content_delta"];
              answerRef.current = newVal;
              // dispatch(setAnswer(newVal));

              dispatch(setAnswer(jsonEventData["content"]["content_delta"]));
            } catch (error) {
              if (error === "AbortError" || error.name === "AbortError") {
                console.log("Stream fetch aborted");
              } else {
                handleError();
                console.error(`Error parsing event data: ${error}`);
              }
            }
          }
        });
      }
    } catch (error) {
      if (error === "AbortError" || error.name === "AbortError") {
        console.log("Stream fetch aborted");
      } else {
        handleError();
        console.log("error while fetching interactions==>", error);
      }
    }
  };

  useEffect(() => {
    console.log("start here", question);
    if (currentChatHistoryId > -1 || question === "") {
      return;
    }
    // setIsSourcesLoading(true);

    fetchInteractionId().then(() => {
      console.log("fetch response done");
    });
  }, [question]);

  const loaderLines = [
    "Tim is analyzing your question and thinking about his thoughtful response...",
    "Reviewing data sources to provide best answers for you...",
    "Tim is looking through WorldCC's Reports and Checklists...",
    "Tim is looking through WorldCC's Webinars...",
    "Tim is looking through WorldCC's Survey Data...",
    "Tim is looking through Tim's Commitment Matters Blogs...",
    "",
  ];
  const finalmessage = "Finalizing your results...";
  const [currentloaderMessage, setCurrentLoaderMessagge] = useState("");

  useEffect(() => {
    setIsLoading(true);
    console.log("triggering loader msgs");
    loaderLines.forEach((message, index) => {
      setTimeout(() => {
        setCurrentLoaderMessagge(message);
      }, index * 2000); // Delay each message by 1 second
    });
  }, [question]);

  const showLoaderMessage = () => {
    return (
      <div className="headerdiv" style={{ marginTop: "1%" }}>
        <img src={loader} alt="loader" />
        <span className="headingtim">{currentloaderMessage}</span>
      </div>
    );
  };

  const processFileName = (input) => {
    // Step 1: Remove all spaces and special characters
    const alphanumericString = "ask_tim_" + input.replace(/[^a-zA-Z0-9]/g, "_");

    // Step 2: Get the current UTC date-time stamp in 'YYYYMMDDHHmmss' format
    const now = new Date();
    let result = "";
    const utcTimestamp =
      "_" +
      now.getUTCFullYear().toString() +
      String(now.getUTCMonth() + 1).padStart(2, "0") +
      String(now.getUTCDate()).padStart(2, "0") +
      "_" +
      String(now.getUTCHours()).padStart(2, "0") +
      String(now.getUTCMinutes()).padStart(2, "0") +
      String(now.getUTCSeconds()).padStart(2, "0");

    // Step 3: Ensure the final string does not exceed 256 characters
    if (alphanumericString.length > 200) {
      const maxLength = 200 - utcTimestamp.length;

      result = alphanumericString.substring(0, maxLength) + utcTimestamp;
    } else {
      // Step 3: Combine the alphanumeric string with the UTC timestamp
      result = alphanumericString + utcTimestamp;
    }

    return result;
  };
  const exportToPdf = async () => {
    try {
      const handleDownload = () => {
        fetch(
          `${process.env.REACT_APP_NEW_API_URL}/interactions/generate_pdf`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              question: question,
              answer: currentAnswer,
              sources: [...currentSources]
                .sort((a, b) => a.content_delta.number - b.content_delta.number) // Sort by 'number' attribute
                .map((item) => {
                  return {
                    title: item.content_delta.title,
                    content: item.content_delta.content,
                    _: "",
                  };
                }),
            }),
          }
        )
          .then((response) => {
            if (!response.ok) {
              throw new Error("Network response was not ok");
            }
            return response.blob();
          })
          .then((blob) => {
            const filename = processFileName(question);
            const url = window.URL.createObjectURL(new Blob([blob]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `${filename}.pdf`);
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
          })
          .catch((error) => {
            console.error(
              "There was a problem with the fetch operation:",
              error
            );
          });
        // const response = await postTemp("interactions/generate_pdf",payload);
        // console.log("response for export to pdf",response);
      };
      handleDownload();
    } catch (error) {
      console.log("error in exporting to pdf", error);
    }
  };
  const openSourcePanel = () => {
    dispatch(openSources());
  };

  const renderExportAndSourcesAtBottom = () => {
    return (
      <div className="exportsources">
        {(showAnswer1 || currentChatHistoryId > -1) &&
          currentSources?.length > 0 && (
            <button
              className="allsources"
              onClick={openSourcePanel}
              title="Show All Sources"
            >
              Sources <img src={logo} alt="logo"></img>
              <img src={logo2} alt="logo"></img>
              <img src={logo3} alt="logo"></img>
            </button>
          )}
        {(showAnswer1 || currentChatHistoryId > -1) && (
          <button
            className="btn btnexport mb-3 w-sm-25 w-md-25"
            title="Export Answer to PDF"
            onClick={exportToPdf}
          >
            Export Answer to PDF
          </button>
        )}
      </div>
    );
  };

  return (
    <div className="parent">
      <div className="headerdiv">
        <img src={logo} alt="world-cc-logo" />
        <span className="headingq">QUESTION</span>
      </div>
      <div className="questionshow">{currentQuestion}</div>

      {currentSources?.length > 0 && (
        <EnhancedSources sources={currentSources} />
      )}

      {currentAnswer && currentAnswer !== "" && isStreaming && (
        <div>
          <div className="export">
            <div className="headerdiv">
              <img src={logo} alt="world-cc-logo" />
              <span className="headingq">ANSWER</span>
            </div>

            <button
              style={{
                display:
                  showAnswer1 || currentChatHistoryId > -1 ? "block" : "none",
              }}
              className="btn btnexport mb-3 w-sm-25 w-md-25"
              title="Export Answer to PDF"
              onClick={exportToPdf}
            >
              Export Answer to PDF
            </button>
          </div>
          <div className="answerdiv">{MarkdownComponent()}</div>
          {renderExportAndSourcesAtBottom()}
        </div>
      )}
      {/* {isShowRetryError &&  <CustomError variant="small" msg=""/>} */}

      {isLoading && currentChatHistoryId === -1 && showLoaderMessage()}
    </div>
  );
};

export default Answer;
